import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { brandListColumns } from '../../../datatablesource'
import { handleError } from '../../../utils/error';
import newRequest from '../../../utils/newRequest';
import Datatable from '../../datatable/Datatable'
import "./brandList.scss";
import { useTranslation } from 'react-i18next';

const BrandList = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [brandList, setBrandList] = useState([]);

  const fetchBrandList = async () => {
    const response = await newRequest.get("/GetAllmakelist");
    setBrandList(response?.data ?? []);
  };

  useEffect(() => {
    const getBrandsList = async () => {
      try {
        await fetchBrandList();
        setIsAuthenticated(true);
        setIsAuthenticating(false);
      }
      catch (error) {
        handleError(error)
        setIsAuthenticated(false);
        setIsAuthenticating(false);
      }
    };
    getBrandsList();
  }, []);

  return (
    <>
      {isAuthenticating ? (
        <div>{t("Loading...")}</div>
      ) : isAuthenticated ? (
        <div>
          <Datatable
            secondaryColor="secondary"
            columnsName={brandListColumns(t)}
            data={brandList}
            title={t("BRAND LIST")}
            uniqueId="brandListId"
            addNewNavigation="/admin/database-config/brand-list/add-new"
            deleteBtnEndPoint="/DeleteMakeListById"
            checkboxSelectionOption={false}
            onImportSuccess={fetchBrandList}
          />
        </div>
      ) : (
        <div>{t("Not authenticated")}</div>
      )}
    </>
  );
}

export default BrandList